'use strict';
import { ApiRequest } from '../../api/request';

class UserImportService extends ApiRequest {
  constructor(appConfig, uiModalDeclarationService, $q, $http) {
    'ngInject';
    super({
      appConfig,
      uiModalDeclarationService,
      $q,
      $http
    });
  }

  openModal() {
    this.modal = this.uiModalDeclarationService.$uibModal.open({
      component: 'userImportComponent',
      size: 'lg'
    });

    return this.modal;
  }

  uploadTemplate(thefile) {
    let formData = new FormData();
    formData.append('file', thefile);

    return this.$http.post(`${this.api}/admin/users/import`, formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    });
  }

  closeModal() {
    if(this.modal) {
      this.modal.close();
    }
  }
}

export default UserImportService;
